import component from './submitButton';

export default component;
